import React, { useEffect, useState } from "react";
import Panel from "./Panel";
import { Download, Trophy, Link, ShieldCheck, Gift, Monitor, Flame } from "lucide-react";

export default function RightSidebar({ visitorStart = 428391 }) {
  const [visitor, setVisitor] = useState(visitorStart);

  useEffect(() => {
    // Slowly tick up to feel "live"
    const t = setInterval(() => setVisitor((v) => v + 1), 20_000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="flex flex-col gap-2">
      {/* Fake ad 1 - LemonWire Pro */}
      <div
        data-testid="ad-pro"
        className="bevel-out overflow-hidden cursor-pointer hover:brightness-105"
        style={{
          background: "linear-gradient(135deg, #FFF59D 0%, #FFEB3B 50%, #FBC02D 100%)",
        }}
      >
        <div className="p-2 relative">
          <div className="absolute top-1 right-1 starburst" style={{ width: 42, height: 42, fontSize: 8 }}>
            <span style={{ fontSize: 10 }}>NEW!</span>
          </div>
          <div
            className="text-[16px] font-bold leading-tight"
            style={{ fontFamily: '"Pixelify Sans", Tahoma, sans-serif', color: "#3D2E00" }}
          >
            LemonWire<br />
            <span className="text-[#1F8020]">PRO</span>
          </div>
          <div className="text-[10px] italic text-[#3D2E00] mt-1">
            No ads. Turbo peers. Unlimited bangers.
          </div>
          <button className="bevel-btn-green text-[11px] font-bold px-3 py-1 mt-2 flex items-center gap-1">
            <Download size={11} /> Download FREE!
          </button>
        </div>
      </div>

      {/* Best viewed in (raised for visibility) */}
      <Panel data-testid="panel-bestviewed" title="Webmaster's Note" icon={Monitor} variant="green">
        <div className="text-[11px] space-y-1.5">
          <div className="flex items-center gap-2">
            <div className="bevel-out w-8 h-8 bg-[#0053e1] flex items-center justify-center text-white font-bold text-[16px] shrink-0">
              e
            </div>
            <span>Best viewed in <b>Internet Explorer 6.0</b> at 1024×768</span>
          </div>
          <div className="text-[10px] text-[#1F8020] italic flex items-center gap-1 pt-1 border-t border-[#9C9A7E]">
            <ShieldCheck size={10} /> Certified malware-free since 2003
          </div>
        </div>
      </Panel>

      {/* Visitor Counter */}
      <Panel data-testid="panel-counter" title="Visitor Counter" icon={Trophy} variant="red" contentClassName="text-center bg-[#0A0A0A]">
        <div className="py-1.5">
          <div className="text-[10px] text-[#FFF176] mb-1 uppercase tracking-widest">You are visitor #</div>
          <div className="flex justify-center">
            {String(visitor).padStart(7, "0").split("").map((d, i) => (
              <span key={i} className="counter-digit">{d}</span>
            ))}
          </div>
          <div className="text-[10px] text-[#FFEB3B] mt-1.5 font-mono">
            Updated every 20 sec
          </div>
        </div>
      </Panel>

      {/* Web Ring */}
      <Panel data-testid="panel-webring" title="P2P Web Ring" icon={Link} variant="blue">
        <div className="text-center">
          <div className="text-[10px] text-[#555] mb-1.5">Part of the MP3 Webring</div>
          <div className="flex items-center justify-center gap-1 flex-wrap">
            <a href="#" onClick={(e) => e.preventDefault()} className="bevel-btn px-1.5 py-0.5 text-[10px]">&lt;&lt; prev</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="bevel-btn px-1.5 py-0.5 text-[10px]">random</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="bevel-btn px-1.5 py-0.5 text-[10px]">about</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="bevel-btn px-1.5 py-0.5 text-[10px]">next &gt;&gt;</a>
          </div>
          <div className="text-[9px] text-[#888] mt-1.5 italic">Previous site: napcity.org</div>
        </div>
      </Panel>

      {/* Awards / badges */}
      <Panel data-testid="panel-awards" title="Site Awards" icon={Trophy} variant="lemon">
        <div className="space-y-1.5">
          <AwardBadge color="#1F8020" label="BeBop" sub="Top P2P Site 2003" />
          <AwardBadge color="#003c9e" label="Cool Site" sub="of the Year 2004" />
          <AwardBadge color="#8B0A14" label="Safe Surf" sub="Certified Clean" />
        </div>
      </Panel>

      {/* Fake ad 2 - Free Ringtones */}
      <div
        data-testid="ad-ringtones"
        className="bevel-out overflow-hidden cursor-pointer text-center p-2"
        style={{
          background:
            "linear-gradient(135deg, #E81123 0%, #FF3030 50%, #8B0A14 100%)",
          color: "white",
          textShadow: "1px 1px 1px rgba(0,0,0,0.5)",
        }}
      >
        <div
          className="text-[15px] font-bold leading-tight uppercase"
          style={{ fontFamily: "Impact, Arial Black, sans-serif", letterSpacing: "0.05em" }}
        >
          FREE<br />RINGTONES
        </div>
        <div className="text-[10px] my-1">Crazy Frog · Dr Dre · NSYNC</div>
        <div className="bg-[#FFEB3B] text-[#8B0A14] text-[10px] font-bold py-0.5 px-2 inline-block">
          CLICK HERE! <span className="blink">➤</span>
        </div>
        <div className="text-[8px] mt-1 opacity-80">*std msg rates apply</div>
      </div>
    </div>
  );
}

function AwardBadge({ color, label, sub }) {
  return (
    <div className="flex items-center gap-2 text-[11px]">
      <div
        className="w-9 h-9 rounded-full shrink-0 flex items-center justify-center text-white text-[9px] font-bold bevel-out"
        style={{
          background: `radial-gradient(circle at 30% 30%, ${color} 0%, ${color} 60%, rgba(0,0,0,0.3) 100%)`,
          textShadow: "1px 1px 1px rgba(0,0,0,0.5)",
        }}
      >
        <Gift size={14} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-bold text-[11px] truncate">{label}</div>
        <div className="text-[9px] text-[#555] italic truncate">{sub}</div>
      </div>
    </div>
  );
}
